"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _useLocals = _interopRequireDefault(require("@micado-digital/react-ui/hooks/useLocals"));
var _Local = _interopRequireDefault(require("@micado-digital/react-ui/components/Local"));
var _de = _interopRequireDefault(require("../../locals/de.json"));
var _en = _interopRequireDefault(require("../../locals/en.json"));
var _IconButton = _interopRequireDefault(require("./IconButton.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const ReactSVGIcon = (0, _component.default)(() => import("@micado-digital/react-svg-icon/ReactSVGIcon"));
const IconButton = _ref => {
  let {
    icon,
    identifier,
    lang,
    value,
    onClick
  } = _ref;
  const {
    REACT_APP_PATH
  } = process.env;
  const [showHint, setShowHint] = (0, _react.useState)(false);
  const css = (0, _IconButton.default)();
  const l = (0, _useLocals.default)({
    lang: lang,
    res: {
      de: _de.default,
      en: _en.default
    }
  });
  (0, _react.useEffect)(() => {
    const hasShownHint = localStorage.getItem("hasShownHint");
    if (!hasShownHint) {
      const showHintTimeout = setTimeout(() => {
        setShowHint(true);
        localStorage.setItem("hasShownHint", "true");
      }, 2500);
      const removeHintTimeout = setTimeout(() => {
        setShowHint(false);
      }, 8000);
      return () => {
        clearTimeout(showHintTimeout);
        clearTimeout(removeHintTimeout);
      };
    }
  }, []);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.iconButton, "mco-bus-stops-icon-button"),
    onClick: onClick
  }, /*#__PURE__*/_react.default.createElement(ReactSVGIcon, {
    src: REACT_APP_PATH + "/img/icons/bus-stops/".concat(icon)
  }), identifier === "location" && /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactBusStops.buttons.locateUser",
    l: l
  }), identifier === "map" && /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactBusStops.buttons.showInMap",
    l: l
  }), identifier === "date" && (value ? value : /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactBusStops.buttons.chooseDate",
    l: l
  })), identifier === "date" && /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(css.dateHint, "mco-bus-stops-icon-button__hint", {
      [css.dateHintShow]: showHint
    })
  }, /*#__PURE__*/_react.default.createElement(_Local.default, {
    identifier: "reactBusStops.buttons.dateHint",
    l: l
  })));
};
var _default = exports.default = IconButton;